import { useDrop } from 'react-dnd';
import {
  IDndLayoutComponentDragObject as IDragObject,
  IDndLayoutComponentDropResult as IDropResult,
} from './DndLayoutComponents.types';

export function useDropLayoutComponent<CollectedProps = unknown>(
  ...args: Parameters<typeof useDrop<IDragObject, IDropResult, CollectedProps>>
) {
  return useDrop(...args);
}
